import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUser
} from 'amazon-cognito-identity-js';

function verify(username, token, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const userData = {
    Username : username,
    Pool : userPool
  };

  Config.region = config.region;
  const cognitoUser = new CognitoUser(userData);
  const prom = new Promise((resolve, reject) => {
    cognitoUser.confirmRegistration(token, true, (err, result) => {
      if (err) {
        reject(err);
      } else {
        resolve(result);
      }
    });
  });

  return prom;
}

export default function verifyUser(username, token, config) {
  return dispatch => dispatch({
    type: 'VERIFY_USER_FETCH',
    payload: verify(username, token, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/verifyUser.js